import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import ConvenientBookingPageStyle from "./convenient-booking-page.module.scss"

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `useStaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `useStaticQuery`: https://www.gatsbyjs.org/docs/use-static-query/
 */

const ConvenientBookingImgMobile = () => {
  const data = useStaticQuery(graphql`
    query {
      contentfulConvenientBookingPage{
        convenientBookingReference{
          hero{
            mobileHeroBgImage{
              fluid(maxWidth: 500){
                ...GatsbyContentfulFluid
              }
            }
          }
        }
      }
    }
  `)

  return <Img alt="Convenient Restaurant Booking - First String Digital" className={ConvenientBookingPageStyle.heroImgMobile} fluid={data.contentfulConvenientBookingPage.convenientBookingReference.hero.mobileHeroBgImage.fluid} />
}

export default ConvenientBookingImgMobile
